import requester from 'utils/requester';

const config = {
  host: 'https://smart-tv.volia.com',
  hostQA: 'https://test.injoy.in.ua',
  users: {
    billing: {
      login: 'smarttv-user',
      pass: 'Cvfhn!Nd',
    },
    analytics: {
      login: 'seostat-user',
      pass: 'Ctj!Cnfn',
    },
  },
  endpoints: {
    promoCodeActivate: '/smarttv-service/smarttv/setPromoCode',
    innerAnalytics: '/smarttv-service/smarttv/putSeoStatLog',
    orderTVOD: '/smarttv-service/smarttv/orderTVOD',
    checkUniqueness: '/smarttv-service/smarttv/checkUniqueness',
    createContract: '/smarttv-service/smarttv/createSmartTvContractWithPassword',
    setEmail: '/smarttv-service/smarttv/setEmail',
    getQrCode: '/smarttv-service/smarttv/smartTvRequestCode',
    smartTVLogin: '/smarttv-service/smarttv/smartTvLogin',
    sendOTP: '/smarttv-service/smarttv/passWordRecoverySendOtp',
    changePass: '/smarttv-service/smarttv/passWordRecoveryChangePassword',
    pinRecovery: '/smarttv-service/smarttv/pinRecovery',
    sendOTPForRegistration: '/smarttv-service/smarttv/sendOtpForRegistration',
    universalAuthSendOTP: '/smarttv-service/smarttv/universalAuthorizationSendOtpV2',
    universalLogin: '/smarttv-service/smarttv/universalAuthorizationLogin',
    checkContract: '/smarttv-service/smarttv/checkContractForActivePhone',
    phoneActivationOTP: '/smarttv-service/smarttv/sendOtpForPhoneActivation',
    phoneActivation: '/smarttv-service/smarttv/phoneActivation',
    getActiveSubscription: '/smarttv-service/smarttv/getCurrentTmInfo',
    getSubscriptions: '/smarttv-service/smarttv/getAvailableTm',
    getActiveAdditionSubscriptions: '/smarttv-service/smarttv/getCurrentSubTmInfo',
    getAdditionalSubscriptions: '/smarttv-service/smarttv/getAvailableSubTm',
    getSubscriptionsByAssetId: '/smarttv-service/smarttv/getTmByAssetIdNew',
    buyMainSubscription: '/smarttv-service/smarttv/orderTm',
    buyAdditionalSubscription: '/smarttv-service/smarttv/orderSubTm',
    deactivateSubscription: '/smarttv-service/smarttv/deactivateSubTm',
    getContractInfo: '/smarttv-service/smarttv/getContractInfo',
    checkIfLifecell: '/smarttv-service/smarttv/checkIfLifecell',
    getPaymentSystems: '/smarttv-service/smarttv/getPaymentSystems',
    getSumForSubs: '/smarttv-service/smarttv/getSumForTm',
    getSumForAdditionalSubs: '/smarttv-service/smarttv/getSumForSubTm',
    getSubForTVOD: '/smarttv-service/smarttv/getSumForTVOD',
    getLoginToken: '/smarttv-service/smarttv/getLoginToken',
    checkLastServiceActivation: '/smarttv-service/smarttv/checkLastServiceActivation',
  },
  getAuthToken: () => {
    const { login, pass } = config.users.billing;
    return btoa(`${login}:${pass}`);
  },
  post({ endpoint, data }) {
    const authToken = this.getAuthToken();

    return requester({
      method: 'post',
      url: `${this.host}${endpoint}`,
      headers: { Authorization: `Basic ${authToken}` },
      extendHeadersWithSession: false,
      appendParams: false,
      data,
    });
  },
};

export default config;
